const configs = require('../config/configs')
const { getCookie } = require('../config/configs')

const moduleFunc = {
  getFaToken: () => {
    return getCookie('FEEC-FA-TOKEN')
  },
  getMemberId: () => {
    return getCookie('FEEC-B2C-UID')
  },
  addToCartBeforeCheck: () => {
    const token = moduleFunc.getFaToken()
    if (!token) {
      window.location.href = configs.loginUrl();
      return false
    } else {
      return true
    }
  }
}
module.exports = moduleFunc
